import './AdsBalance.sass';

import React, { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'react-router5';

import {
  Block,
  Button,
  Form,
  FormItem,
  Header,
  InfoBlock,
  Input,
  ScrollView,
} from '$uikit';
import { amountFractionDigits, formatAmount, formatInputAmount } from '$utils/number';
import { toastActions } from '$store/toast';
import { Api } from '$api';
import { batchActions } from '$store';
import { mainActions, mainSelector } from '$store/main';
import { adsActions } from '$store/ads';
import { goBack, showModal } from '$navigation/helper';
import { useCurrentUserInfo, useTranslator } from '$hooks';
import { _confirm } from '$utils';
import { REFILL_TON } from '$shared/constants/pages';
import { CurrencyEnum } from '$store/models';

export const AdsBalance: FC<{ withdraw?: boolean }> = () => {
  const dispatch = useDispatch();
  const t = useTranslator();
  const router = useRouter();
  const user = useCurrentUserInfo();
  const [amount, setAmount] = useState('');
  const { balance } = useSelector(mainSelector);

  const handleSubmit = () => {
    if (+amount <= 0) return;

    _confirm(t('ads_balance_top_up_confirm', { amount }), () => {
      dispatch(toastActions.setToastLoading());
      Api.post('/ads/balance', { amount: +amount, withdrawal: false })
        .then((data: any) => {
          dispatch(
            batchActions(
              mainActions.setBalance(data.userBalance),
              adsActions.setAdsBalance(data.adsBalance),
            ),
          );
          dispatch(toastActions.setToastSuccess());
          goBack();
        })
        .catch((e) => dispatch(toastActions.setToastFail(e.message)));
    });
  };

  return (
    <>
      <Header showBackButton>{t('ads_balance_title')}</Header>
      <ScrollView>
        <Form>
          <FormItem>
            <InfoBlock type="warning">{t('ads_balance_top_up_warning')}</InfoBlock>
          </FormItem>
          {user.verified === 2 && (
            <Block className="AdsBalance__account_balance">
              <div className="AdsBalance__account_balance__cont">
                <div className="AdsBalance__account_balance__label">
                  {t('ads_balance_account_balance')}
                </div>
                <div className="AdsBalance__account_balance__value">
                  {formatAmount(balance, CurrencyEnum.TON)}
                </div>
              </div>
              <div className="AdsBalance__account_balance__btn">
                <Button
                  size="small"
                  mode="light"
                  onClick={() => router.navigate(REFILL_TON)}
                >
                  {t('ads_balance_buy')}
                </Button>
              </div>
            </Block>
          )}
          <FormItem
            title={t('ads_balance_amount')}
            description={t('ads_balance_amount_top_up_caption')}
          >
            <Input
              placeholder={t('ads_balance_amount_placeholder')}
              value={amount}
              onChange={({ target }) =>
                setAmount(formatInputAmount(target.value, amountFractionDigits('ton')))
              }
            />
          </FormItem>
          <FormItem>
            {(+amount > balance || balance === 0) && (
              <div
                style={{ paddingBottom: 16 }}
                onClick={() => showModal('balance', false, { currency: 'ton' })}
              >
                <InfoBlock type="warning" arrow>
                  Недостаточно средств на балансе, вы можете купить TON в Telegram.
                </InfoBlock>
              </div>
            )}
            <Button onClick={handleSubmit}>{t('ads_balance_top_up')}</Button>
          </FormItem>
        </Form>
      </ScrollView>
    </>
  );
};
